export const ALPHABET_LETTERS = ["C", "K", "W", "F", "S", "O"] as const;
export const SYMBOL_LETTERS = [
  "⌘",
  "⌥",
  "⌃",
  "↵",
  "←",
  "↓",
  "↑",
  "→",
  "[",
  "]",
  "/",
] as const;
